import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Link,
  Button,
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Home as HomeIcon,
} from '@mui/icons-material';

const HelpPage: React.FC = () => {
  const handleBackToApp = () => {
    // Use window.location instead of React Router since this page
    // is rendered outside the Routes component
    window.location.href = '/';
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        py: 4,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 5 },
            textAlign: 'center',
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom sx={{ mb: 4 }}>
            Need help?
          </Typography>

          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            For any questions or concerns on how to use the app please contact Nick Watkins:
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 4 }}>
            {/* Email */}
            <Paper
              elevation={1}
              sx={{
                p: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4,
                },
              }}
            >
              <EmailIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box sx={{ flex: 1, textAlign: 'left' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Email
                </Typography>
                <Link
                  href="mailto:WatNick712@gmail.com"
                  sx={{
                    fontSize: '1.1rem',
                    fontWeight: 500,
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  WatNick712@gmail.com
                </Link>
              </Box>
            </Paper>

            {/* Phone */}
            <Paper
              elevation={1}
              sx={{
                p: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4,
                },
              }}
            >
              <PhoneIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box sx={{ flex: 1, textAlign: 'left' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Phone
                </Typography>
                <Link
                  href="tel:+15749932331"
                  sx={{
                    fontSize: '1.1rem',
                    fontWeight: 500,
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  574-993-2331
                </Link>
              </Box>
            </Paper>

            {/* Address */}
            <Paper
              elevation={1}
              sx={{
                p: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4,
                },
              }}
            >
              <HomeIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box sx={{ flex: 1, textAlign: 'left' }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Address
                </Typography>
                <Link
                  href="https://maps.google.com/?q=3826+Dudley+Drive,+Mishawaka,+IN+46544"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontSize: '1.1rem',
                    fontWeight: 500,
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  3826 Dudley Drive, Mishawaka, IN 46544
                </Link>
              </Box>
            </Paper>
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={handleBackToApp}
            sx={{ mt: 5 }}
          >
            Back to App
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default HelpPage;

